import React from 'react';
import './MangaPage.css';
import adApp from '../../assets/ad_app.png';

const MangaAccessNotice = ({
    title = 'Раздел манги доступен только в приложении',
    message = 'Скачайте приложение, чтобы открыть раздел.',
}) => {
    return (
        <div className="full-width-da-block manga-access">
            <img src={adApp} alt="" />
            <h1 className="da-title">{title}</h1>
            <p className="da-text">{message}</p>
            <div>
                <button
                    className="da-button"
                    onClick={() => window.open('https://animixapp.ety.one')}
                >
                    Скачать приложение
                </button>
            </div>
        </div>
    );
};

export default MangaAccessNotice;
